import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_COLLECTABLE_SUPPORTING_DOCS_PDF_REQUEST = 'GET_COLLECTABLE_SUPPORTING_DOCS_PDF_REQUEST';
export const GET_COLLECTABLE_SUPPORTING_DOCS_PDF_SUCCESS = 'GET_COLLECTABLE_SUPPORTING_DOCS_PDF_SUCCESS';
export const GET_COLLECTABLE_SUPPORTING_DOCS_PDF_FAILURE = 'GET_COLLECTABLE_SUPPORTING_DOCS_PDF_FAILURE';
export const GET_COLLECTABLE_SUPPORTING_DOCS_PDF_CLEAR = 'GET_COLLECTABLE_SUPPORTING_DOCS_PDF_CLEAR';

function request(collectableSupportingDocType) {
  return {
    type: GET_COLLECTABLE_SUPPORTING_DOCS_PDF_REQUEST,
    isFetchingCollectablePdf: true,
    downloadRequestCollectableSupportingDocType: collectableSupportingDocType
  };
}

function receive(collectableSupportingDocPdfData) {
  return {
    type: GET_COLLECTABLE_SUPPORTING_DOCS_PDF_SUCCESS,
    isFetchingCollectablePdf: false,
    downloadRequestCollectableSupportingDocType: null,
    collectableSupportingDocPdfData,
  };
}

function reject() {
  return {
    type: GET_COLLECTABLE_SUPPORTING_DOCS_PDF_FAILURE,
    isFetchingCollectablePdf: false,
    downloadRequestCollectableSupportingDocType: null
  };
}

function clear() {
  return {
    type: GET_COLLECTABLE_SUPPORTING_DOCS_PDF_CLEAR
  };
}

export function getCollectableSupportingDocPdf(requestData, intl, isPreview = true) {
  return (dispatch) => {
    dispatch(request(requestData.collectableSupportingDocType));

    return ApiService
      .getCollectableSupportingDocPdf(requestData, isPreview, { responseType: 'arraybuffer' })
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        const status = error.response && error.response.status;
        if (status !== 401) {
          dispatch(handleException(
            { response: { data: { code: 500, message: intl.formatMessage({ id: 'form.downloadError' }) } } },
            reject,
            !status || (status !== 404 && status !== 401)
          ));
        }
      });
  };
}

export function clearCollectableSupportingDocPdfDownload() {
  return (dispatch) => {
    dispatch(clear());
  };
}
